// Datos de regiones y comunas de Chile
export const chileRegions = [
  { value: 'Arica y Parinacota', label: 'Región de Arica y Parinacota', shortLabel: 'Arica' },
  { value: 'Tarapacá', label: 'Región de Tarapacá', shortLabel: 'Tarapacá' },
  { value: 'Antofagasta', label: 'Región de Antofagasta', shortLabel: 'Antof.' },
  { value: 'Atacama', label: 'Región de Atacama', shortLabel: 'Atacama' },
  { value: 'Coquimbo', label: 'Región de Coquimbo', shortLabel: 'Coquimbo' },
  { value: 'Valparaíso', label: 'Región de Valparaíso', shortLabel: 'Valpo' },
  { value: 'Metropolitana', label: 'Región Metropolitana', shortLabel: 'RM' },
  { value: 'O\'Higgins', label: 'Región del Libertador General Bernardo O\'Higgins', shortLabel: "O'Higg." },
  { value: 'Maule', label: 'Región del Maule', shortLabel: 'Maule' },
  { value: 'Ñuble', label: 'Región de Ñuble', shortLabel: 'Ñuble' },
  { value: 'Biobío', label: 'Región del Biobío', shortLabel: 'Biobío' },
  { value: 'La Araucanía', label: 'Región de La Araucanía', shortLabel: 'Arauc.' },
  { value: 'Los Ríos', label: 'Región de Los Ríos', shortLabel: 'Ríos' },
  { value: 'Los Lagos', label: 'Región de Los Lagos', shortLabel: 'Lagos' },
  { value: 'Aysén', label: 'Región Aysén del General Carlos Ibáñez del Campo', shortLabel: 'Aysén' },
  { value: 'Magallanes', label: 'Región de Magallanes y de la Antártica Chilena', shortLabel: 'Magall.' }
];

const REGION_SHORT_BY_VALUE = chileRegions.reduce((acc, region) => {
  acc[region.value] = region.shortLabel || region.value;
  return acc;
}, {});

/** Etiqueta corta para ejes de gráficos. */
export const getChileRegionShortLabel = (value = '') => {
  const normalized = normalizeChileRegion(value);
  if (!normalized) return 'S/R';
  if (normalized === 'Sin región') return 'S/R';
  return REGION_SHORT_BY_VALUE[normalized] || normalized;
};

const foldRegionKey = (value = '') =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

/** Alias frecuentes → valor canónico de `chileRegions`. */
const REGION_ALIASES = {
  santiago: 'Metropolitana',
  'region metropolitana': 'Metropolitana',
  rm: 'Metropolitana',
  metropolitana: 'Metropolitana',
  valparaiso: 'Valparaíso',
  biobio: 'Biobío',
  'bio bio': 'Biobío',
  araucania: 'La Araucanía',
  'la araucania': 'La Araucanía',
  ohiggins: "O'Higgins",
  "o higgins": "O'Higgins",
  nuble: 'Ñuble',
  aysen: 'Aysén',
  'aisen': 'Aysén',
};

const CANONICAL_BY_FOLDED = chileRegions.reduce((acc, region) => {
  acc[foldRegionKey(region.value)] = region.value;
  return acc;
}, {});

/**
 * Unifica variantes de región (acentos, casing, alias) al valor canónico.
 * Devuelve string vacío si no hay región.
 */
export const normalizeChileRegion = (value = '') => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const folded = foldRegionKey(raw);
  if (REGION_ALIASES[folded]) return REGION_ALIASES[folded];
  if (CANONICAL_BY_FOLDED[folded]) return CANONICAL_BY_FOLDED[folded];
  return raw;
};

export const chileCommunes = {
  'Arica y Parinacota': [
    { value: 'Arica', label: 'Arica' },
    { value: 'Camarones', label: 'Camarones' },
    { value: 'General Lagos', label: 'General Lagos' },
    { value: 'Putre', label: 'Putre' }
  ],
  'Tarapacá': [
    { value: 'Alto Hospicio', label: 'Alto Hospicio' },
    { value: 'Camiña', label: 'Camiña' },
    { value: 'Colchane', label: 'Colchane' },
    { value: 'Huara', label: 'Huara' },
    { value: 'Iquique', label: 'Iquique' },
    { value: 'Pica', label: 'Pica' },
    { value: 'Pozo Almonte', label: 'Pozo Almonte' }
  ],
  'Antofagasta': [
    { value: 'Antofagasta', label: 'Antofagasta' },
    { value: 'Calama', label: 'Calama' },
    { value: 'María Elena', label: 'María Elena' },
    { value: 'Mejillones', label: 'Mejillones' },
    { value: 'Ollagüe', label: 'Ollagüe' },
    { value: 'San Pedro de Atacama', label: 'San Pedro de Atacama' },
    { value: 'Sierra Gorda', label: 'Sierra Gorda' },
    { value: 'Taltal', label: 'Taltal' },
    { value: 'Tocopilla', label: 'Tocopilla' }
  ],
  'Atacama': [
    { value: 'Alto del Carmen', label: 'Alto del Carmen' },
    { value: 'Caldera', label: 'Caldera' },
    { value: 'Chañaral', label: 'Chañaral' },
    { value: 'Copiapó', label: 'Copiapó' },
    { value: 'Diego de Almagro', label: 'Diego de Almagro' },
    { value: 'Freirina', label: 'Freirina' },
    { value: 'Huasco', label: 'Huasco' },
    { value: 'Tierra Amarilla', label: 'Tierra Amarilla' },
    { value: 'Vallenar', label: 'Vallenar' }
  ],
  'Coquimbo': [
    { value: 'Andacollo', label: 'Andacollo' },
    { value: 'Canela', label: 'Canela' },
    { value: 'Combarbalá', label: 'Combarbalá' },
    { value: 'Coquimbo', label: 'Coquimbo' },
    { value: 'Illapel', label: 'Illapel' },
    { value: 'La Higuera', label: 'La Higuera' },
    { value: 'La Serena', label: 'La Serena' },
    { value: 'Los Vilos', label: 'Los Vilos' },
    { value: 'Monte Patria', label: 'Monte Patria' },
    { value: 'Ovalle', label: 'Ovalle' },
    { value: 'Paiguano', label: 'Paiguano' },
    { value: 'Punitaqui', label: 'Punitaqui' },
    { value: 'Río Hurtado', label: 'Río Hurtado' },
    { value: 'Salamanca', label: 'Salamanca' },
    { value: 'Vicuña', label: 'Vicuña' }
  ],
  'Valparaíso': [
    { value: 'Algarrobo', label: 'Algarrobo' },
    { value: 'Cabildo', label: 'Cabildo' },
    { value: 'Calera', label: 'Calera' },
    { value: 'Calle Larga', label: 'Calle Larga' },
    { value: 'Cartagena', label: 'Cartagena' },
    { value: 'Casablanca', label: 'Casablanca' },
    { value: 'Catemu', label: 'Catemu' },
    { value: 'Concón', label: 'Concón' },
    { value: 'El Quisco', label: 'El Quisco' },
    { value: 'El Tabo', label: 'El Tabo' },
    { value: 'Hijuelas', label: 'Hijuelas' },
    { value: 'Isla de Pascua', label: 'Isla de Pascua' },
    { value: 'Juan Fernández', label: 'Juan Fernández' },
    { value: 'La Cruz', label: 'La Cruz' },
    { value: 'La Ligua', label: 'La Ligua' },
    { value: 'Limache', label: 'Limache' },
    { value: 'Llaillay', label: 'Llaillay' },
    { value: 'Los Andes', label: 'Los Andes' },
    { value: 'Nogales', label: 'Nogales' },
    { value: 'Olmué', label: 'Olmué' },
    { value: 'Panquehue', label: 'Panquehue' },
    { value: 'Papudo', label: 'Papudo' },
    { value: 'Petorca', label: 'Petorca' },
    { value: 'Puchuncaví', label: 'Puchuncaví' },
    { value: 'Putaendo', label: 'Putaendo' },
    { value: 'Quillota', label: 'Quillota' },
    { value: 'Quilpué', label: 'Quilpué' },
    { value: 'Quintero', label: 'Quintero' },
    { value: 'Rinconada', label: 'Rinconada' },
    { value: 'San Antonio', label: 'San Antonio' },
    { value: 'San Esteban', label: 'San Esteban' },
    { value: 'San Felipe', label: 'San Felipe' },
    { value: 'Santa María', label: 'Santa María' },
    { value: 'Santo Domingo', label: 'Santo Domingo' },
    { value: 'Valparaíso', label: 'Valparaíso' },
    { value: 'Villa Alemana', label: 'Villa Alemana' },
    { value: 'Viña del Mar', label: 'Viña del Mar' },
    { value: 'Zapallar', label: 'Zapallar' }
  ],
  'Metropolitana': [
    { value: 'Alhué', label: 'Alhué' },
    { value: 'Buin', label: 'Buin' },
    { value: 'Calera de Tango', label: 'Calera de Tango' },
    { value: 'Cerrillos', label: 'Cerrillos' },
    { value: 'Cerro Navia', label: 'Cerro Navia' },
    { value: 'Colina', label: 'Colina' },
    { value: 'Conchalí', label: 'Conchalí' },
    { value: 'Curacaví', label: 'Curacaví' },
    { value: 'El Bosque', label: 'El Bosque' },
    { value: 'El Monte', label: 'El Monte' },
    { value: 'Estación Central', label: 'Estación Central' },
    { value: 'Huechuraba', label: 'Huechuraba' },
    { value: 'Independencia', label: 'Independencia' },
    { value: 'Isla de Maipo', label: 'Isla de Maipo' },
    { value: 'La Cisterna', label: 'La Cisterna' },
    { value: 'La Florida', label: 'La Florida' },
    { value: 'La Granja', label: 'La Granja' },
    { value: 'La Pintana', label: 'La Pintana' },
    { value: 'La Reina', label: 'La Reina' },
    { value: 'Lampa', label: 'Lampa' },
    { value: 'Las Condes', label: 'Las Condes' },
    { value: 'Lo Barnechea', label: 'Lo Barnechea' },
    { value: 'Lo Espejo', label: 'Lo Espejo' },
    { value: 'Lo Prado', label: 'Lo Prado' },
    { value: 'Macul', label: 'Macul' },
    { value: 'Maipú', label: 'Maipú' },
    { value: 'María Pinto', label: 'María Pinto' },
    { value: 'Melipilla', label: 'Melipilla' },
    { value: 'Ñuñoa', label: 'Ñuñoa' },
    { value: 'Padre Hurtado', label: 'Padre Hurtado' },
    { value: 'Paine', label: 'Paine' },
    { value: 'Pedro Aguirre Cerda', label: 'Pedro Aguirre Cerda' },
    { value: 'Peñaflor', label: 'Peñaflor' },
    { value: 'Peñalolén', label: 'Peñalolén' },
    { value: 'Pirque', label: 'Pirque' },
    { value: 'Providencia', label: 'Providencia' },
    { value: 'Pudahuel', label: 'Pudahuel' },
    { value: 'Puente Alto', label: 'Puente Alto' },
    { value: 'Quilicura', label: 'Quilicura' },
    { value: 'Quinta Normal', label: 'Quinta Normal' },
    { value: 'Recoleta', label: 'Recoleta' },
    { value: 'Renca', label: 'Renca' },
    { value: 'San Bernardo', label: 'San Bernardo' },
    { value: 'San Joaquín', label: 'San Joaquín' },
    { value: 'San José de Maipo', label: 'San José de Maipo' },
    { value: 'San Miguel', label: 'San Miguel' },
    { value: 'San Pedro', label: 'San Pedro' },
    { value: 'San Ramón', label: 'San Ramón' },
    { value: 'Santiago', label: 'Santiago' },
    { value: 'Talagante', label: 'Talagante' },
    { value: 'Tiltil', label: 'Tiltil' },
    { value: 'Vitacura', label: 'Vitacura' }
  ],
  'O\'Higgins': [
    { value: 'Chépica', label: 'Chépica' },
    { value: 'Chimbarongo', label: 'Chimbarongo' },
    { value: 'Codegua', label: 'Codegua' },
    { value: 'Coinco', label: 'Coinco' },
    { value: 'Coltauco', label: 'Coltauco' },
    { value: 'Doñihue', label: 'Doñihue' },
    { value: 'Graneros', label: 'Graneros' },
    { value: 'La Estrella', label: 'La Estrella' },
    { value: 'Las Cabras', label: 'Las Cabras' },
    { value: 'Litueche', label: 'Litueche' },
    { value: 'Lolol', label: 'Lolol' },
    { value: 'Machalí', label: 'Machalí' },
    { value: 'Malloa', label: 'Malloa' },
    { value: 'Marchihue', label: 'Marchihue' },
    { value: 'Mostazal', label: 'Mostazal' },
    { value: 'Nancagua', label: 'Nancagua' },
    { value: 'Navidad', label: 'Navidad' },
    { value: 'Olivar', label: 'Olivar' },
    { value: 'Palmilla', label: 'Palmilla' },
    { value: 'Paredones', label: 'Paredones' },
    { value: 'Peralillo', label: 'Peralillo' },
    { value: 'Peumo', label: 'Peumo' },
    { value: 'Pichidegua', label: 'Pichidegua' },
    { value: 'Pichilemu', label: 'Pichilemu' },
    { value: 'Placilla', label: 'Placilla' },
    { value: 'Pumanque', label: 'Pumanque' },
    { value: 'Quinta de Tilcoco', label: 'Quinta de Tilcoco' },
    { value: 'Rancagua', label: 'Rancagua' },
    { value: 'Rengo', label: 'Rengo' },
    { value: 'Requínoa', label: 'Requínoa' },
    { value: 'San Fernando', label: 'San Fernando' },
    { value: 'San Vicente', label: 'San Vicente' },
    { value: 'Santa Cruz', label: 'Santa Cruz' }
  ],
  'Maule': [
    { value: 'Cauquenes', label: 'Cauquenes' },
    { value: 'Chanco', label: 'Chanco' },
    { value: 'Colbún', label: 'Colbún' },
    { value: 'Constitución', label: 'Constitución' },
    { value: 'Curepto', label: 'Curepto' },
    { value: 'Curicó', label: 'Curicó' },
    { value: 'Empedrado', label: 'Empedrado' },
    { value: 'Hualañé', label: 'Hualañé' },
    { value: 'Licantén', label: 'Licantén' },
    { value: 'Linares', label: 'Linares' },
    { value: 'Longaví', label: 'Longaví' },
    { value: 'Maule', label: 'Maule' },
    { value: 'Molina', label: 'Molina' },
    { value: 'Parral', label: 'Parral' },
    { value: 'Pelarco', label: 'Pelarco' },
    { value: 'Pelluhue', label: 'Pelluhue' },
    { value: 'Pencahue', label: 'Pencahue' },
    { value: 'Rauco', label: 'Rauco' },
    { value: 'Retiro', label: 'Retiro' },
    { value: 'Romeral', label: 'Romeral' },
    { value: 'Sagrada Familia', label: 'Sagrada Familia' },
    { value: 'San Clemente', label: 'San Clemente' },
    { value: 'San Javier', label: 'San Javier' },
    { value: 'San Rafael', label: 'San Rafael' },
    { value: 'Talca', label: 'Talca' },
    { value: 'Teno', label: 'Teno' },
    { value: 'Vichuquén', label: 'Vichuquén' },
    { value: 'Villa Alegre', label: 'Villa Alegre' },
    { value: 'Yerbas Buenas', label: 'Yerbas Buenas' }
  ],
  'Ñuble': [
    { value: 'Bulnes', label: 'Bulnes' },
    { value: 'Chillán', label: 'Chillán' },
    { value: 'Chillán Viejo', label: 'Chillán Viejo' },
    { value: 'Cobquecura', label: 'Cobquecura' },
    { value: 'Coelemu', label: 'Coelemu' },
    { value: 'Coihueco', label: 'Coihueco' },
    { value: 'El Carmen', label: 'El Carmen' },
    { value: 'Ninhue', label: 'Ninhue' },
    { value: 'Ñiquén', label: 'Ñiquén' },
    { value: 'Pemuco', label: 'Pemuco' },
    { value: 'Pinto', label: 'Pinto' },
    { value: 'Portezuelo', label: 'Portezuelo' },
    { value: 'Quillón', label: 'Quillón' },
    { value: 'Quirihue', label: 'Quirihue' },
    { value: 'Ránquil', label: 'Ránquil' },
    { value: 'San Carlos', label: 'San Carlos' },
    { value: 'San Fabián', label: 'San Fabián' },
    { value: 'San Ignacio', label: 'San Ignacio' },
    { value: 'San Nicolás', label: 'San Nicolás' },
    { value: 'Treguaco', label: 'Treguaco' },
    { value: 'Yungay', label: 'Yungay' }
  ],
  'Biobío': [
    { value: 'Alto Biobío', label: 'Alto Biobío' },
    { value: 'Antuco', label: 'Antuco' },
    { value: 'Arauco', label: 'Arauco' },
    { value: 'Cabrero', label: 'Cabrero' },
    { value: 'Cañete', label: 'Cañete' },
    { value: 'Chiguayante', label: 'Chiguayante' },
    { value: 'Concepción', label: 'Concepción' },
    { value: 'Contulmo', label: 'Contulmo' },
    { value: 'Coronel', label: 'Coronel' },
    { value: 'Curanilahue', label: 'Curanilahue' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Hualpén', label: 'Hualpén' },
    { value: 'Hualqui', label: 'Hualqui' },
    { value: 'Laja', label: 'Laja' },
    { value: 'Lebu', label: 'Lebu' },
    { value: 'Los Álamos', label: 'Los Álamos' },
    { value: 'Los Ángeles', label: 'Los Ángeles' },
    { value: 'Lota', label: 'Lota' },
    { value: 'Mulchén', label: 'Mulchén' },
    { value: 'Nacimiento', label: 'Nacimiento' },
    { value: 'Negrete', label: 'Negrete' },
    { value: 'Penco', label: 'Penco' },
    { value: 'Quilaco', label: 'Quilaco' },
    { value: 'Quilleco', label: 'Quilleco' },
    { value: 'San Pedro de la Paz', label: 'San Pedro de la Paz' },
    { value: 'San Rosendo', label: 'San Rosendo' },
    { value: 'Santa Bárbara', label: 'Santa Bárbara' },
    { value: 'Santa Juana', label: 'Santa Juana' },
    { value: 'Talcahuano', label: 'Talcahuano' },
    { value: 'Tirúa', label: 'Tirúa' },
    { value: 'Tomé', label: 'Tomé' },
    { value: 'Tucapel', label: 'Tucapel' },
    { value: 'Yumbel', label: 'Yumbel' }
  ],
  'La Araucanía': [
    { value: 'Angol', label: 'Angol' },
    { value: 'Carahue', label: 'Carahue' },
    { value: 'Cholchol', label: 'Cholchol' },
    { value: 'Collipulli', label: 'Collipulli' },
    { value: 'Cunco', label: 'Cunco' },
    { value: 'Curacautín', label: 'Curacautín' },
    { value: 'Curarrehue', label: 'Curarrehue' },
    { value: 'Ercilla', label: 'Ercilla' },
    { value: 'Freire', label: 'Freire' },
    { value: 'Galvarino', label: 'Galvarino' },
    { value: 'Gorbea', label: 'Gorbea' },
    { value: 'Lautaro', label: 'Lautaro' },
    { value: 'Loncoche', label: 'Loncoche' },
    { value: 'Lonquimay', label: 'Lonquimay' },
    { value: 'Los Sauces', label: 'Los Sauces' },
    { value: 'Lumaco', label: 'Lumaco' },
    { value: 'Melipeuco', label: 'Melipeuco' },
    { value: 'Nueva Imperial', label: 'Nueva Imperial' },
    { value: 'Padre Las Casas', label: 'Padre Las Casas' },
    { value: 'Perquenco', label: 'Perquenco' },
    { value: 'Pitrufquén', label: 'Pitrufquén' },
    { value: 'Pucón', label: 'Pucón' },
    { value: 'Purén', label: 'Purén' },
    { value: 'Renaico', label: 'Renaico' },
    { value: 'Saavedra', label: 'Saavedra' },
    { value: 'Temuco', label: 'Temuco' },
    { value: 'Teodoro Schmidt', label: 'Teodoro Schmidt' },
    { value: 'Toltén', label: 'Toltén' },
    { value: 'Traiguén', label: 'Traiguén' },
    { value: 'Victoria', label: 'Victoria' },
    { value: 'Vilcún', label: 'Vilcún' },
    { value: 'Villarrica', label: 'Villarrica' }
  ],
  'Los Ríos': [
    { value: 'Corral', label: 'Corral' },
    { value: 'Futrono', label: 'Futrono' },
    { value: 'La Unión', label: 'La Unión' },
    { value: 'Lago Ranco', label: 'Lago Ranco' },
    { value: 'Lanco', label: 'Lanco' },
    { value: 'Los Lagos', label: 'Los Lagos' },
    { value: 'Máfil', label: 'Máfil' },
    { value: 'Mariquina', label: 'Mariquina' },
    { value: 'Paillaco', label: 'Paillaco' },
    { value: 'Panguipulli', label: 'Panguipulli' },
    { value: 'Río Bueno', label: 'Río Bueno' },
    { value: 'Valdivia', label: 'Valdivia' }
  ],
  'Los Lagos': [
    { value: 'Ancud', label: 'Ancud' },
    { value: 'Calbuco', label: 'Calbuco' },
    { value: 'Castro', label: 'Castro' },
    { value: 'Chaitén', label: 'Chaitén' },
    { value: 'Chonchi', label: 'Chonchi' },
    { value: 'Cochamó', label: 'Cochamó' },
    { value: 'Curaco de Vélez', label: 'Curaco de Vélez' },
    { value: 'Dalcahue', label: 'Dalcahue' },
    { value: 'Fresia', label: 'Fresia' },
    { value: 'Frutillar', label: 'Frutillar' },
    { value: 'Futaleufú', label: 'Futaleufú' },
    { value: 'Hualaihué', label: 'Hualaihué' },
    { value: 'Llanquihue', label: 'Llanquihue' },
    { value: 'Los Muermos', label: 'Los Muermos' },
    { value: 'Maullín', label: 'Maullín' },
    { value: 'Osorno', label: 'Osorno' },
    { value: 'Palena', label: 'Palena' },
    { value: 'Puerto Montt', label: 'Puerto Montt' },
    { value: 'Puerto Octay', label: 'Puerto Octay' },
    { value: 'Puerto Varas', label: 'Puerto Varas' },
    { value: 'Puqueldón', label: 'Puqueldón' },
    { value: 'Purranque', label: 'Purranque' },
    { value: 'Puyehue', label: 'Puyehue' },
    { value: 'Queilén', label: 'Queilén' },
    { value: 'Quellón', label: 'Quellón' },
    { value: 'Quemchi', label: 'Quemchi' },
    { value: 'Quinchao', label: 'Quinchao' },
    { value: 'Río Negro', label: 'Río Negro' },
    { value: 'San Juan de la Costa', label: 'San Juan de la Costa' },
    { value: 'San Pablo', label: 'San Pablo' }
  ],
  'Aysén': [
    { value: 'Aysén', label: 'Aysén' },
    { value: 'Chile Chico', label: 'Chile Chico' },
    { value: 'Cisnes', label: 'Cisnes' },
    { value: 'Cochrane', label: 'Cochrane' },
    { value: 'Coyhaique', label: 'Coyhaique' },
    { value: 'Guaitecas', label: 'Guaitecas' },
    { value: 'Lago Verde', label: 'Lago Verde' },
    { value: 'O\'Higgins', label: 'O\'Higgins' },
    { value: 'Río Ibáñez', label: 'Río Ibáñez' },
    { value: 'Tortel', label: 'Tortel' }
  ],
  'Magallanes': [
    { value: 'Antártica', label: 'Antártica' },
    { value: 'Cabo de Hornos', label: 'Cabo de Hornos' },
    { value: 'Laguna Blanca', label: 'Laguna Blanca' },
    { value: 'Natales', label: 'Natales' },
    { value: 'Porvenir', label: 'Porvenir' },
    { value: 'Primavera', label: 'Primavera' },
    { value: 'Punta Arenas', label: 'Punta Arenas' },
    { value: 'Río Verde', label: 'Río Verde' },
    { value: 'San Gregorio', label: 'San Gregorio' },
    { value: 'Timaukel', label: 'Timaukel' },
    { value: 'Torres del Paine', label: 'Torres del Paine' }
  ]
};

const foldCommuneKey = (value = '') =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const COMMUNE_LOOKUP = Object.entries(chileCommunes).flatMap(([region, communes]) =>
  (communes || []).map((commune) => ({
    region,
    commune: commune.value,
    key: foldCommuneKey(commune.value),
  }))
).sort((a, b) => b.key.length - a.key.length);

/**
 * Infers Chilean commune + region from free-text address / delivery place.
 * Prefers longer commune names to avoid partial matches.
 */
export const inferChileLocationFromText = (value = '') => {
  const text = foldCommuneKey(value);
  if (!text) return { commune: '', region: '' };
  const padded = ` ${text} `;
  const match = COMMUNE_LOOKUP.find((entry) => padded.includes(` ${entry.key} `));
  if (!match) return { commune: '', region: '' };
  return { commune: match.commune, region: match.region };
};
